import Button from '../../../../components/Button'
import Panel, { PanelBody, PanelHeader } from '../../../../components/Panel'
import TablePaymentConditions from './TablePaymentConditions'
import usePaymentCondition from './usePaymentCondition'

export default function PaymentConditions() {
    const open = usePaymentCondition()
    return (
        <Panel mode="form">
            <PanelHeader title="Condiciones de pago">
                <Button outline size="sm" onClick={() => open()}>
                    + Agregar
                </Button>
            </PanelHeader>
            <PanelBody>
                <TablePaymentConditions />
            </PanelBody>
        </Panel>
    )
}
